import cntl from 'cntl'

export const submenu = {
    container: (className = '') => cntl`
        lg:dark:bg-gray-accent-dark
        text-[14px]
        lg:p-12
        p-0
        max-w-screen-xl
        mx-auto
        px-4
        ${className}
    `,
    section: {
        title: (className) => cntl`
            text-lg
            lg:text-xl
            font-bold
            ${className}
            `,
        description: (className = '') => cntl`
            my-3
            text-almost-black
            dark:text-white
            ${className}`,
        link: (className) => cntl`
            text-light-yellow
            hover:text-light-yellow
            font-bold
            ${className}
        `,
    },
}

const border = cntl`
    lg:border-b-0
    border-b
    border-dashed
    border-gray-accent-light
    dark:border-opacity-30
`

export const menuItem = (hideBorder) => cntl`
    lg:flex
    lg:justify-center
    menu-item
    ${!hideBorder ? border : ''}
`
export const link = (className = '', hovered = false) => cntl`
    relative
    font-semibold
    px-3.5
    py-3
    lg:py-2
    text-sm
    dark:text-white
    dark:hover:text-white
    text-almost-black
    hover:text-almost-black
    flex
    items-center
    space-between
    w-full
    space-x-1.5
    rounded-t-md
    ${hovered ? 'lg:bg-white lg:dark:bg-gray-accent-dark lg:shadow-md' : ''}
    ${className}
`

export const darkToggle = (className = '', hovered = false) => cntl`

.toggle {
    --size: 1.5rem;
    appearance: none;
    outline: none;
    cursor: pointer;
    width: var(--size);
    height: var(--size);
    box-shadow: inset calc(var(--size) * 0.33) calc(var(--size) * -0.25) 0;
    border-radius: 999px;
    color: #00B39F;
    transition: all 300ms;
    vertical-align: middle;
  }

  .toggle:checked {
    ray-size: calc(var(--size) * -0.4);
    offset-orthogonal: calc(var(--size) * 0.65);
    offset-diagonal: calc(var(--size) * 0.45);
    transform: scale(0.75);
    bg: white;
    color: #fa0;
    color: #3c494f;
    box-shadow: inset 0 0 0 var(--size), calc(var(--offset-orthogonal) * -1) 0 0 var(--ray-size), var(--offset-orthogonal) 0 0 var(--ray-size), 0 calc(var(--offset-orthogonal) * -1) 0 var(--ray-size), 0 var(--offset-orthogonal) 0 var(--ray-size), calc(var(--offset-diagonal) * -1) calc(var(--offset-diagonal) * -1) 0 var(--ray-size), var(--offset-diagonal) var(--offset-diagonal) 0 var(--ray-size), calc(var(--offset-diagonal) * -1) var(--offset-diagonal) 0 var(--ray-size), var(--offset-diagonal) calc(var(--offset-diagonal) * -1) 0 var(--ray-size);
  }

  .toggle {
    z-index: 1;
  }

  `
